<template>
  <div class="side-widget">
    <span class="side-widget__label">
      <span v-if="label">{{ label }}</span>
      <slot v-else name="label"></slot>
    </span>
    <span class="side-widget__action">
      <slot name="action"></slot>
    </span>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    label: String,
  },
})
export default class SideWidget extends Vue {}
</script>

<style lang="scss" scoped>
.side-widget {
  display: flex;
  flex-direction: column;
  font-size: 14px;

  &__label {
    font-size: 12px;
  }
}
</style>
